import Vue from 'vue'

import store from '../store'

Vue.filter('timezone', (value, dateStyle, timeStyle) => {
  if (!value) {
    return value
  }

  const fmt = new Intl.DateTimeFormat(store.getters.locale, {
    timeZone: store.getters.timezone,
    timeStyle: timeStyle || store.getters.date_format.time,
    dateStyle: dateStyle || store.getters.date_format.date,
    calendar: store.getters.date_format.calendar
  })

  return fmt.format(new Date(value))
})
